// extracted by mini-css-extract-plugin
export default {"auth":"authorization_auth__PP+0B","wrapper":"authorization_wrapper__W5CBr","column_form":"authorization_column_form__Nj6IF","enter_title":"authorization_enter_title__4cEbb"};